import { useContext, type DetailedHTMLProps, type InputEvent, type TextareaHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

import { FormLabelForContext } from "@/contexts/FormLabelForContext";

export function Textarea({
  className,
  onInput,
  ...props
}: DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>) {
  const id = useContext(FormLabelForContext);

  function handleInput(e: InputEvent<HTMLTextAreaElement>) {
    e.currentTarget.setCustomValidity("");
    onInput?.(e);
  }

  return (
    <textarea
      id={props.id ?? id}
      onInput={handleInput}
      className={twMerge(
        "field-sizing-content min-h-32 w-full rounded-sm border border-divider bg-white p-2 user-invalid:outline-2 user-invalid:outline-danger focus:outline-2 focus:outline-turtle",
        className,
      )}
      {...props}
    />
  );
}
